import React, { Fragment, useEffect, useMemo, useState } from "react";
import closeIcon from "../Assets/Images/close.png";
import { useDispatch } from "react-redux";
import { getInvestmentTimeline } from "../store/actions/investment/getInvestmentTimeline";
import Loader from "./Utils/Loader";
import { timeformatter } from "../utils/dateformatter";
import emptyState from "../Assets/Images/emptyState.png";

const InvesmentCycleTimelineModal = ({
  investment,
  type,
  close,
  investmentId,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(
      getInvestmentTimeline({
        payload: {
          cycle_id: investment?.id,
          investment_type: type === "REAL-ESTATE" ? "property" : "business",
        },
        investmentId: investmentId,
        cb: (data) => {
          setData(data);
          setLoading(false);
        },
        failed: () => {
          setLoading(false);
        },
      })
    );
  }, []);

  const step1 = useMemo(() => data[0]?.date, [data]);
  const step2 = useMemo(() => data[1]?.date, [data]);
  const step3 = useMemo(() => data[2]?.date, [data]);
  const step4 = useMemo(() => data[3]?.date, [data]);
  const step5 = useMemo(() => data[4]?.date, [data]);

  return (
    <div className="relative min-h-[591px] max-h-[80%] w-full max-w-[553px] flex flex-col rounded-[12px] border-[1px] border-[#f2f2f7] bg-white shadow-lg">
      <div className="absolute top-3 right-3 cursor-pointer p-3">
        <img
          onClick={() => {
            close();
          }}
          src={closeIcon}
          alt="Close"
          className="cursor-pointer w-6 h-6"
        />
      </div>

      <h2 className="text-[24px] mt-[10px] font-[500] text-[#131e3d] p-5">
        {investment?.name} Timeline
      </h2>

      <div className="flex-1 flex show-scroll-bar flex-col overflow-y-auto justify-between pb-[30px]">
        {loading ? (
          <div className="flex-1 flex justify-center items-center">
            <Loader />
          </div>
        ) : data?.length > 0 ? (
          <div className="flex py-1 px-[30px] items-start gap-[12px] ">
            <div className="flex flex-col gap-[8px] items-center mt-[10px]">
              {data?.map((timeline, index) => (
                <Fragment key={index}>
                  <div className="flex flex-col items-center">
                    {timeline?.status?.toLocaleLowerCase() !== "pending" ? (
                      <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                        <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                      </div>
                    ) : (
                      <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                        <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                      </div>
                    )}
                  </div>
                  {index === data?.length - 1 ? (
                    <></>
                  ) : timeline?.description ? (
                    <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[120px]"></div>
                  ) : (
                    <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>
                  )}
                </Fragment>
              ))}
            </div>
            <div className="flex flex-col mt-[4px] ">
              {data?.map((timeline, index) => (
                <div
                  key={index}
                  className={`text-[16px] ${
                    timeline?.description ? "h-[150px]" : "h-[80px]"
                  } ${
                    step1 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                  } ] font-[500]`}
                >
                  {timeline?.title}
                  {timeline?.description ? (
                    <div className="border my-2 shadow rounded-[8px] py-2 px-3 border-[#0000000F] bg-[#0000000A] ">
                      <h4 className="text-[12px] font-[400] text-[#000000]">
                        {timeline?.description}
                      </h4>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="text-[14px] font-[400] text-[#9C9C9E]">
                    {timeline?.date
                      ? timeformatter(timeline?.date, "formal")
                      : "___"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="w-full flex-col h-[400px] flex justify-center items-center">
            <img
              src={emptyState}
              alt=""
              className=" mb-[5px] w-[76px] h-[76px] "
            />
            <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
              Timeline Not Uploaded
            </div>
          </div>
        )}
        <div className=" pr-[30px] ">
          <button
            onClick={() => {
              close();
            }}
            className=" w-[93px] float-end h-[45px] rounded-[8px] text-white justify-center items-center flex font-[500] bg-[#6935D3] "
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvesmentCycleTimelineModal;
